import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormLayoutFieldContainer } from '@fluid/layouts';
import { Button } from '@fluid/buttons';

import UserNameField from './UserNameField';
import PasswordField from './PasswordField';
import { getDataAttributes, getLocaleText } from '../../utils/LoginUtils';
import { NO_OP_FN, PRIMARY_BTN_BG_COLOR_PROP } from '../../Constants';
import { isDark } from '../../utils/cssUtil';

const LoginForm = (props) => {
    const {
        loginConfig,
        isInteractive,
        locale,
        onUsernameChange,
        onPasswordChange,
        isOAuth2Flow,
        theme,
    } = props;

    let { values } = props;
    values = values ?? {};

    const { loginButtonGroup } = loginConfig ?? {};
    const { loginButtonLabel, dataAttributes } = loginButtonGroup ?? {};
    const buttonLabel = getLocaleText(loginButtonLabel, locale);

    const buttonProps = {
        ...getDataAttributes(dataAttributes),
        type: 'submit',
        isPrimary: true,
        text: buttonLabel,
        isDisabled:
            (isInteractive && (!values.username || !values.password)) ||
            !isInteractive,
    };

    if (!isInteractive) {
        buttonProps.tabIndex = '-1';
    }

    const isDarkBackground = isDark(theme, PRIMARY_BTN_BG_COLOR_PROP);
    buttonProps.contextCls = isDarkBackground ? 'is-dark-bg' : 'is-light-bg';

    return (
        <Fragment>
            <FormLayoutFieldContainer contextCls="username-container">
                <UserNameField
                    locale={locale}
                    isInteractive={isInteractive}
                    loginConfig={loginConfig}
                    onUsernameChange={onUsernameChange}
                    username={values.username}
                    isOAuth2Flow={isOAuth2Flow}
                />
            </FormLayoutFieldContainer>
            <FormLayoutFieldContainer contextCls="password-container">
                <PasswordField
                    locale={locale}
                    isInteractive={isInteractive}
                    loginConfig={loginConfig}
                    onPasswordChange={onPasswordChange}
                    password={values.password}
                />
            </FormLayoutFieldContainer>
            <FormLayoutFieldContainer>
                <Button {...buttonProps} />
            </FormLayoutFieldContainer>
        </Fragment>
    );
};

LoginForm.defaultProps = {
    onUsernameChange: NO_OP_FN,
    onPasswordChange: NO_OP_FN,

    values: {},
};

LoginForm.propTypes = {
    contextCls: PropTypes.string,
    locale: PropTypes.string.isRequired,
    loginConfig: PropTypes.object.isRequired,
    theme: PropTypes.object,
    isInteractive: PropTypes.bool,

    onUsernameChange: PropTypes.func,
    onPasswordChange: PropTypes.func,

    values: PropTypes.object,
    isOAuth2Flow: PropTypes.bool,
};

export default LoginForm;
